<script lang="ts">
    import Connection from "./clienthandler";
    import { WEBSOCKET_URL } from "./state";
    import Modal from "./Modal.svelte";

    import { fly } from "svelte/transition";
    import { circOut } from "svelte/easing";

    const easing = circOut;
    const duration = 600;

    const inflyParams = {
        duration,
        easing,
        x: 200,
    };

    const outflyParams = {
        easing,
        duration,
        x: -200,
    };

    import Game from "./game/Game.svelte";
    import Lobby from "./lobby/Lobby.svelte";
    import Menu from "./menu/Menu.svelte";
    import { state } from "./state";
    import Background from "./Background.svelte";
    import QuickPlayLobby from "./lobby/QuickPlayLobby.svelte";
    import DevBar from "./DevBar.svelte";

    let hasConnected = false;
    let lostConnection = false;

    let modalText = "Connecting...";
    let modalVisible = true;
    let modalTimeoutPassed = false;
    let connectedOnce = false;
    let connected = false;
    let connectionLost = false;

    setTimeout(() => (modalTimeoutPassed = true), 300);

    $state.connection = new Connection(WEBSOCKET_URL);
    $state.connection.registerMessageListener("all", (message) => {
        if (message.type === "ConnectedToServer") {
            connectedOnce = true;
            modalVisible = false;
        } else if (message.type === "LostConnection") {
            connectionLost = true;
            modalVisible = true;

            if (connectedOnce) {
                modalText = "Lost connection";
            } else {
                modalText = "Couldn't connect to the server";
            }
        }
    });

    window["conn"] = $state.connection;

    $: {
        if ($state.lobbyId != null) {
            $state.displayLobbyId = $state.lobbyId.toString().padStart(6, "0");
        }
    }

    console.log({ connection: $state.connection });
</script>

<body>
    <Modal
        titleText={modalText}
        reasonText=""
        visible={modalVisible && modalTimeoutPassed}
        onClose={() => setTimeout(() => location.reload(), 500)}
    />
    {#if $state.currentPage === "menu"}
        <div class="holder" in:fly={inflyParams} out:fly={outflyParams}>
            <Menu />
        </div>
    {:else if $state.currentPage === "lobby"}
        <div class="holder" in:fly={inflyParams} out:fly={outflyParams}>
            <Lobby />
        </div>
    {:else if $state.currentPage === "quickplay_lobby"}
        <div class="holder" in:fly={inflyParams} out:fly={outflyParams}>
            <QuickPlayLobby />
        </div>
    {:else if $state.currentPage === "game"}
        <div class="holder" in:fly={inflyParams} out:fly={outflyParams}>
            <Game />
        </div>
    {/if}
    <Background />
    <!-- <DevBar /> -->
</body>

<style>
    body {
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .holder {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 100%;
        height: 100%;
    }
</style>
